<div class="page-container home">
  <div class="main-container" [class.bottom-gap]="isH5">
    @if (!localStorageService.loginToken) {
      <div
        class="home-banner"
        style="--banner: url({{ 'assets/images/home/export-hero-bg.png' | preferWebp }})"
        role="img"
        aria-label="Pubs.com crypto casino homepage image. Bitcoin slots, live casino and wallet onboarding"
      >
        <div id="head" style="--head: url({{ 'assets/images/home/avatar.png' | preferWebp }})"></div>
        <div class="textArea">
          <span class="title">{{ 'home_head_title' | translate }}</span>
          <span class="sub-title">{{ 'home_head_sub_title' | translate }}</span>
          <cs-button
            [style]="{ width: isH5 ? '100%' : '357px' }"
            color="primary"
            size="large"
            label="Sign Up Now"
            (buttonClick)="appService.jumpToRegister()"
          ></cs-button>
          <span class="connect">
            <p class="text">Instant Sign Up with your Crypto Wallet</p>
            <div class="icons">
              <!-- @defer 宿主，見 wallet-connect-cta.component.ts 的說明 -->
              <app-wallet-connect-cta></app-wallet-connect-cta>
            </div>
          </span>
        </div>
      </div>
      <div class="text-behind">Straight to the fun. Play using your favourite crypto.</div>
    } @else {
      <!-- 轮播图 -->
      <app-normal-carousel class="container" [buildFor]="'FrontPage'" [autoplay]="true"></app-normal-carousel>
    }

    <!-- 體育熱門賽事 -->
    <!-- <app-swiper-unit
      class="container"
      *ngIf="isHotSport"
      [title]="'pop_eve' | translate"
      [data]="sportData"
      [imgCarouselConfig]="imgCarouselConfig"
      [titleIcon]="'assets/images/home/hot_sport_tip.png'"
      [for]="'sport'"
    ></app-swiper-unit> -->

    <!-- 原真人娱乐场&小游戏 等 -->
    <ng-container *ngFor="let item of renderHomeScenesInfo(); trackBy: trackByFn; let i = index">
      <app-swiper-unit
        class="container"
        [style.order]="i"
        (clickItem)="clickGameItem($event)"
        (clickTitle)="clickLabelTitle(item)"
        [data]="item?.gameLists"
        [count]="item?.count"
        [title]="item?.labelName"
        [titleIcon]="item?.icon"
        [row]="item?.multiLine || 1"
        [titleHref]="item?.titleHref"
        [redirectMethod]="item?.redirectMethod"
        [isH5]="isH5"
      ></app-swiper-unit>
    </ng-container>

    <!-- casino and sport entrance -->
    <div class="entrance" [style.order]="0">
      @for (item of entranceList; track $index) {
        <div class="item" [class.coming]="item.closeTxt" (click)="jumpTo(item.route, item.closeTxt)">
          <div class="info">
            <div class="wrap">
              <div class="tt">{{ item.title }}</div>
              <div class="cont">{{ item.content }}</div>
            </div>
            <i class="fi-arrow-right"></i>
          </div>
          <div class="pic">
            <img [src]="item.imgUrl" [attr.alt]="item.alt" />
          </div>
          <div class="close-text" *ngIf="item.closeTxt">{{ item.closeTxt }}</div>
        </div>
      }
    </div>

    <!-- wc2026 Banner -->
    <!-- <div class="container" [style.order]="0">
      <div class="activity-banner">
        <div class="item">
          <div class="box">
            <div class="wrap">
              <p>Immerse yourself into</p>
              <p>the World Championship</p>
            </div>
            <cs-button
              class="for-tablet-and-down"
              label="Explore"
              [color]="'primary'"
              (buttonClick)="jumpTo('activity/worldcup2026')"
            ></cs-button>
          </div>
          <div class="box">
            <img src="assets/images/activity/worldcup2026/main-logo.png" alt="World Cup 2026 banner" />
          </div>
        </div>
        <div class="item for-desktop">
          <cs-button
            class=""
            label="Explore"
            [color]="'primary'"
            (buttonClick)="jumpTo('activity/worldcup2026')"
          ></cs-button>
        </div>
      </div>
    </div> -->

    <!-- 游戏供应商 -->
    <app-swiper-provider-list class="container" [style.order]="0"></app-swiper-provider-list>
    <!-- 大贏家新版 -->
    <app-swiper-unit
      *ngIf="winnerLoading || winnerList.length > 0"
      class="container"
      [data]="winnerList"
      [title]="'Latest Winners'"
      [titleIcon]="'assets/images/home/latest-winners.png' | preferWebp"
      [isProvider]="false"
      [hasHover]="false"
      [hasMask]="false"
      [ratio]="1 / 0.4"
      [imgCarouselConfig]="latestWinnerImgCarouselConfig"
      [for]="'winner'"
      [isFiatDisplay]="isFiatDisplay"
    ></app-swiper-unit>
    <!-- Deposit Banner -->
    <div class="container" [style.order]="0">
      <div class="deposit-banner">
        <div class="item">
          <div class="box">
            <p>Deposit your crypto,</p>
            <p>or buy it using FIAT</p>
          </div>
          <div class="box">
            @if (localStorageService.theme == 'sun') {
              <img src="assets/images/home/deposit_banner_light.png" alt="Crypto deposit options illustration" />
            } @else {
              <img src="assets/images/home/deposit_banner_dark.png" alt="Crypto deposit options illustration" />
            }
          </div>
        </div>
        <div class="item">
          <cs-button
            label="Deposit Now"
            color="accent"
            (buttonClick)="walletService.openDepositModalByLastDepositMode()"
          ></cs-button>
        </div>
      </div>
    </div>

    <!-- 每日竞赛 -->
    <app-daily-races
      [style.order]="98"
      [gameCategories]="['SportsBook', 'Esports', 'Lottery', 'LiveCasino', 'SlotGame', 'Chess']"
    ></app-daily-races>

    <!-- SEO -->
    <div class="container" style="margin-top: var(--xl); order: 99">
      <app-seo-block variant="home"></app-seo-block>
    </div>
  </div>
</div>
